import { Typography } from '@mui/material'
import Chip from 'Theme/Chip'

export const ContentTypeChip = ({ label, icon }) => (
  <Chip
    label={
      <Typography
        variant="overline"
        color="text.secondary"
        fontWeight={900}
        textTransform="uppercase"
      >
        {label}
      </Typography>
    }
    icon={icon}
    sx={{
      padding: '6px 12px',
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      height: '24px',
      gap: '8px',
      margin: '0 !important',
      backdropFilter: 'blur(4px)',
      '& .MuiChip-icon': {
        marginLeft: '-6px',
      },
      '& .MuiChip-label': {
        marginRight: '0 !important',
      },
    }}
  />
)
